

import CommonApi from './../commonApi';

const maintenanceOperationByModelApi = new CommonApi(
  'maintenanceOperationByModel',
  'Виды работ'
);

export default {
  ...maintenanceOperationByModelApi
};
